var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useMixpanel, useService } from '@tenderd/track-web-utils';
import { Form, message } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useGroupGeofencePageContext } from '../../../GroupGeofencePage.context';
var useLocationMarkers = function () {
    var context = useGroupGeofencePageContext();
    var _a = __read(useState(false), 2), modal = _a[0], setModal = _a[1];
    var _b = __read(useState(), 2), selectedLocation = _b[0], setSelectedLocation = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var LMRef = useRef();
    var service = useService();
    var mixpanel = useMixpanel();
    var defaultValues = {
        name: '',
        location: { lat: 0, lon: 0 },
        _id: '',
    };
    var _d = __read(Form.useForm(), 1), form = _d[0];
    useEffect(function () {
        LMRef.current && form.setFieldsValue(LMRef.current);
    }, [LMRef.current]);
    var onSubmit = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _id = _a._id, values = __rest(_a, ["_id"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    setLoading(true);
                    if (!_id) return [3 /*break*/, 2];
                    return [4 /*yield*/, service.server
                            .updateGroupGeofenceLocationMarker(context.selectedGeofence._id, _id, values)
                            .then(function () {
                            var _a;
                            message.success('Location marker updated');
                            mixpanel.track('Location marker updated', { extension: 'track' });
                            context.setSelectedGeofence(__assign(__assign({}, context.selectedGeofence), { locationMarkers: ((_a = context.selectedGeofence.locationMarkers) === null || _a === void 0 ? void 0 : _a.map(function (locationMarker) {
                                    if (locationMarker._id === _id) {
                                        return __assign(__assign({}, locationMarker), values);
                                    }
                                    return locationMarker;
                                })) || [] }));
                            setModal(false);
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2: 
                // create
                return [4 /*yield*/, service.server
                        .addGroupGeofenceLocationMarker(context.selectedGeofence._id, values)
                        .then(function (res) {
                        var updatedGeofence = __assign(__assign({}, context.selectedGeofence), res);
                        message.success('Location marker added');
                        mixpanel.track('Location marker added', { extension: 'track' });
                        context.updateGeofenceData('update', updatedGeofence);
                        context.setSelectedGeofence(updatedGeofence);
                        context.setMode(undefined);
                        setModal(false);
                    })];
                case 3:
                    // create
                    _b.sent();
                    _b.label = 4;
                case 4:
                    setLoading(false);
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    console.log(error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return {
        modal: modal,
        form: form,
        defaultValues: defaultValues,
        selectedLocation: selectedLocation,
        loading: loading,
        LMRef: LMRef,
        setSelectedLocation: setSelectedLocation,
        onSubmit: onSubmit,
        setModal: setModal,
    };
};
export default useLocationMarkers;
